// Shared attendance-status presentation. Statuses come from the backend:
// worked (derived from Clock In) | no_schedule | time_off | absent | unclassified.
export const STATUS_META = {
    worked: {
        label: "Worked",
        short: "Worked",
        cell: "bg-emerald-50 text-emerald-800 border-emerald-200",
        dot: "bg-emerald-500",
        badge: "bg-emerald-100 text-emerald-800 border-emerald-200",
    },
    no_schedule: {
        label: "No Schedule / No Workload",
        short: "No Schedule",
        cell: "bg-slate-100 text-slate-600 border-slate-200",
        dot: "bg-slate-400",
        badge: "bg-slate-100 text-slate-700 border-slate-200",
    },
    time_off: {
        label: "Approved Time Off",
        short: "Time Off",
        cell: "bg-blue-50 text-[#0066D9] border-blue-200",
        dot: "bg-[#0066D9]",
        badge: "bg-blue-100 text-[#0066D9] border-blue-200",
    },
    absent: {
        label: "Absent",
        short: "Absent",
        cell: "bg-red-50 text-[#E6002C] border-red-200",
        dot: "bg-[#E6002C]",
        badge: "bg-red-100 text-[#E6002C] border-red-200",
    },
    unclassified: {
        label: "Unclassified",
        short: "Unclassified",
        cell: "bg-amber-50 text-amber-700 border-amber-200",
        dot: "bg-amber-400",
        badge: "bg-amber-100 text-amber-800 border-amber-200",
    },
};

export const MANUAL_STATUSES = ["no_schedule", "time_off", "absent"];

export const meta = (status) => STATUS_META[status] || STATUS_META.unclassified;
